import { render, staticRenderFns } from "./solution3.vue?vue&type=template&id=12befec0&scoped=true"
import script from "./solution3.vue?vue&type=script&lang=js"
export * from "./solution3.vue?vue&type=script&lang=js"
import style0 from "./solution3.vue?vue&type=style&index=0&id=12befec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12befec0",
  null
  
)

export default component.exports